import React from 'react';
import { motion } from 'framer-motion';
const CART_LINK = 'https://creaycrecepro.shop/checkouts/cn/hWNAWLippdzlLj2KbA0phaJ0/es-ar?_r=AQABXe45mcGQp256mwxnogXyZaN3X8TPMhy8oauCA9MChHo&preview_theme_id=193700921425';
export function FinalClose() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="py-16 px-4 bg-gradient-to-br from-primary/10 to-accent/10" data-id="element-61">
      <motion.div {...fadeInUp} className="max-w-3xl mx-auto text-center" data-id="element-62">
        <p className="text-xl md:text-2xl text-dark/80 leading-relaxed mb-8" data-id="element-63">
          Hoy podés seguir postergando, seguir improvisando comidas y seguir
          cayendo en lo mismo de siempre…
        </p>

        <p className="text-xl md:text-2xl text-dark font-semibold leading-relaxed mb-12" data-id="element-64">
          o podés aprovechar esta oportunidad y tener, desde hoy, una biblioteca
          completa de recetas ricas, simples y listas para ayudarte a comer
          mejor sin culpa.
        </p>

        <motion.a href={CART_LINK} className="inline-block w-full md:w-auto bg-primary hover:bg-primary/90 text-white font-bold text-xl px-12 py-6 rounded-xl shadow-2xl transition-all duration-300" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-65">
          SÍ, QUIERO ACCESO INMEDIATO
        </motion.a>
      </motion.div>
    </section>;
}